export default function Faq() {
	const faqContainers = document.querySelectorAll('.faq-block__body');

	if (faqContainers.length) {
		faqContainers.forEach(function (el) {
			el.addEventListener('click', function (e) {
				const btn = e.target.closest('.faqs__btn');
				if (!btn) return;

				const content = btn.querySelector('.faqs__content');
				const statusIcon = btn.querySelector('.faqs__status');

				const isOpen = content.classList.toggle('show');
				btn.classList.toggle('show', isOpen);
				statusIcon.classList.toggle('faqs__status_open', isOpen);
			});
		});
	}
}
